"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return {
            backgroundColor: theme.palette.default.main,
            color: theme.palette.default.contrastText
        };
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiSnackbarContent.js.map
